import dynamic from 'next/dynamic';

import { useAuthState } from '@contexts/auth/AuthContext';
import {
  FavoriteItemType,
  WishListItemViewModel,
  WishListViewModel,
} from '@api/v3';
import { PaletteColor } from '@utils/types';

const MyFavoriteAfterLogin = dynamic(() => import('./MyFavoriteAfterLogin'));
const MyFavoriteBeforeLogin = dynamic(() => import('./MyFavoriteBeforeLogin'));

const MyFavoriteComponent = ({
  itemId,
  itemName,
  imageUrl,
  type,
  isListing = false,
  itemUrl,
  favoriteLists,
  isTour = false,
  refetchFavoriteLists,
  defaultList,
  defaultListItems,
  refetchDefaultList,
  fontSize,
  fontColor,
  isHomePage,
  isFeaturedTour,
}: {
  itemId?: number;
  itemName?: string;
  imageUrl?: string;
  isListing?: boolean;
  type: FavoriteItemType;
  itemUrl?: string;
  favoriteLists?: WishListViewModel[];
  refetchFavoriteLists?: any;
  defaultList?: WishListViewModel;
  defaultListItems?: WishListItemViewModel[];
  refetchDefaultList?: any;
  fontSize?: number;
  fontColor?: PaletteColor;
  isHomePage?: boolean;
  isFeaturedTour?: boolean;
  isTour?: boolean;
}) => {
  const { userInfo } = useAuthState();

  return (
    <>
      {userInfo.id ? (
        <MyFavoriteAfterLogin
          itemId={itemId}
          itemName={itemName}
          isListing={isListing}
          type={type}
          itemUrl={itemUrl}
          imageUrl={imageUrl}
          favoriteLists={favoriteLists}
          refetchFavoriteLists={refetchFavoriteLists}
          defaultList={defaultList}
          defaultListItems={defaultListItems}
          refetchDefaultList={refetchDefaultList}
          fontsize={fontSize}
          isTour={isTour}
          fontColor={fontColor}
          isHomePage={isHomePage}
          isFeaturedTour={isFeaturedTour}
        />
      ) : (
        <MyFavoriteBeforeLogin fontsize={fontSize} fontColor={fontColor} />
      )}
    </>
  );
};

export default MyFavoriteComponent;
